module.exports = __webpack_public_path__ + "img/calendar-black.e0f9ef6e.svg";